export default __webpack_public_path__ + "static/media/graniglia-pav.8df63c05.png";